import React, {Component}   from 'react';
import PropTypes            from 'prop-types';

let FaSpinner = require('react-icons/lib/fa/spinner');

class FullPageSpinner extends Component {
    constructor(props) {
        super(props);
        this.state = {
            active: false,
            completion: 0,
        };
    }

    render() {
        return (
            <div>
                {this.props.isActive ?
                    <div className={this.props.messages ? 'full-page-spinner with-message' : 'full-page-spinner'}>
                        <div className={"indicator"}>
                            <FaSpinner className="spin" />
                        </div>

                        <p className="header"><strong>
                            {this.props.header ? this.props.header : 'Loading...'}
                        </strong></p>
                    </div>
                : null}
            </div>
        );
    }
}

FullPageSpinner.propTypes = {
    onClick:            PropTypes.func,
    header:             PropTypes.string,
    numberOfUploads:    PropTypes.number,
    messages:           PropTypes.array,
    isActive:           PropTypes.bool,
};

FullPageSpinner.defaultProps = {
    header: null,
};

export default FullPageSpinner;


// WEBPACK FOOTER //
// ./src/components/Fragments/FullPageSpinner.js